import Vue from 'vue';
export class EduacProvider {
  declare $vue: Vue; 
}